const MAX_LENGTH = 300;
const HTML_MARKERS = /<!doctype|<html|<body|<head|<script/i;

type ApiErrorPayload = { data: { message: string } };

const isApiErrorPayload = (error: unknown): error is ApiErrorPayload => {
  const data = (error as ApiErrorPayload | null)?.data;
  return (
    typeof data === "object" &&
    data !== null &&
    typeof data.message === "string"
  );
};

export const sanitizeReportErrorMessage = (
  message: string,
  fallback: string,
): string => {
  const trimmed = message.trim();
  const safe =
    trimmed.length > 0 &&
    trimmed.length <= MAX_LENGTH &&
    !HTML_MARKERS.test(trimmed);
  return safe ? trimmed : fallback;
};

export const extractReportErrorMessage = (
  error: unknown,
  fallback: string,
): string => {
  if (!isApiErrorPayload(error)) return fallback;
  return sanitizeReportErrorMessage(error.data.message, fallback);
};
